import React, { useCallback, useContext, useEffect, useState } from "react";
import { Col, Form, Button, Row } from "react-bootstrap";
import "../../../Pages/Home/home.css";
import "./JoinWaitList.scss";
import userService from "../../../services/userService";
import { Link, useNavigate, useParams } from "react-router-dom";
import { message } from "antd";
import { ThemeContext } from "../../../context/themeProvider";
import { GoogleReCaptcha } from "react-google-recaptcha-v3";

export default function JoinWaitListForm() {
  const navigate = useNavigate();
  const formDetails = {
    email: "",
  };
  const [formData, setFormData] = useState(formDetails);
  const [validated, setValidated] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [validEmail, setValidEmail] = useState(true);
  const { referralId } = useParams();
  const [handleSubmitBtn, setHandleSubmitBtn] = useState(false);
  const [termsCheckbox, setTermsCheckbox] = useState(false);
  const { setLoading } = useContext(ThemeContext);
  const [captchaToken, setCaptchaToken] = useState();
  const [refreshReCaptcha, setRefreshReCaptcha] = useState(false);

  const onVerify = useCallback(
    (token) => {
      if (!token) console.log("captcha failed !", token);
      else setCaptchaToken(token);
    },
    [refreshReCaptcha]
  );

  useEffect(() => {
    if (formData.email) {
      emailValidation();
    }
  }, [formData.email]);

  /**
   * Validate email address received from input
   * @returns boolean
   */
  const emailValidation = () => {
    const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{1,4})+$/;
    const tld = formData?.email?.split(".")[1]?.length;
    if (regex.test(formData?.email) === false || tld <= 1) {
      setErrorMsg("Valid email is required !");
      setValidEmail(false);
    } else {
      setErrorMsg(null);
      setValidEmail(true);
    }
  };
  const handleSubmit = async (e) => {
    emailValidation();
    setValidated(true);
    e.preventDefault();
    e.stopPropagation();
    e.preventDefault();
    const form = e.currentTarget;
    let dataToSend = "";
    if (
      form.checkValidity() === false ||
      !validEmail ||
      !termsCheckbox ||
      !captchaToken
    ) {
      console.log("form invalid!");
      return;
    } else {
      dataToSend = formData;
      dataToSend.token = captchaToken;
      dataToSend.agreeTAndC = termsCheckbox;
      if (referralId && referralId !== "signup") {
        dataToSend.referralCode = referralId;
      }
      try {
        // console.log("dataToSend", dataToSend);
        setHandleSubmitBtn(true);
        setLoading(true);
        const response = await userService.registerUser(dataToSend);
        // console.log("register res", response);
        if (response?.error) {
          message.destroy();
          message.error("Something went wrong in submitting form");
        } else {
          message.destroy();
          message.success("Verification email sent successfully!");
          const { password, ...restOfData } = response?.data;
          localStorage.setItem("user-signup", JSON.stringify(restOfData));
          // console.log("restData", restOfData);
        }
      } catch (error) {
        if (error?.response?.data?.data?.alreadyExist) {
          navigate("/login");
        }
        console.log("regsiter error", error);
        message.destroy();
        message.error(
          error?.response?.data?.message ||
            "Error caused in submitting the form"
        );
      }
    }
    setRefreshReCaptcha((r) => !r);
    setHandleSubmitBtn(false);
    setLoading(false);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  return (
    <Col lg={5} id="captcha">
      <div className="mb-4">
        <h4>Register now</h4>
        <p>
          Be among the first to experience the cutting-edge innovation that
          awaits!
        </p>
        <p>We've got surprises, waiting just for you.</p>
      </div>

      <GoogleReCaptcha
        onVerify={onVerify}
        refreshReCaptcha={refreshReCaptcha}
      />

      <Form
        noValidate
        validated={validated}
        onSubmit={handleSubmit}
        id="join-form"
      >
        <Form.Group className="mb-3">
          <Form.Label>My Email is</Form.Label>
          <Form.Control
            required
            type="email"
            name="email"
            placeholder="Enter email"
            value={formData.email}
            onChange={handleInputChange}
            size="lg"
            isInvalid={!validEmail}
          />
          <Form.Control.Feedback type="invalid">
            <span> {formData.email && errorMsg} </span>
            <span> {!formData.email && "E-mail is required !"} </span>
          </Form.Control.Feedback>
        </Form.Group>
        <Row>
          <Col className="policy_text">
            {" "}
            <Form.Group>
              <Form.Check
                required
                type="checkbox"
                checked={termsCheckbox}
                onChange={() => setTermsCheckbox(!termsCheckbox)}
                label={
                  <p>
                    Agree to our{" "}
                    <Link to="/terms" target="_blank">
                      Terms & Conditions
                    </Link>
                  </p>
                }
                aria-label="Agree to our Terms & Conditions"
                feedback="Please agree to continue"
                feedbackType="invalid"
              />
            </Form.Group>
          </Col>
        </Row>
        <Button
          size="lg"
          className="d-block Join-btn"
          type="submit"
          disabled={handleSubmitBtn}
        >
          Register
        </Button>
      </Form>
    </Col>
  );
}
